import handleChange from "../utils/handleChange";
import handleChangeNumber from "../utils/handleChangeNumber";
import InputNumber from "./InputNumber";
import DateInput from "./InputDate";
import TimeInput from "./InputTime";

import { FaFileExcel } from "react-icons/fa6";
import { IoMdCheckmark } from "react-icons/io";
import { RiResetLeftFill } from "react-icons/ri";
import { MdOutlineKeyboardDoubleArrowUp, MdOutlineKeyboardDoubleArrowDown } from "react-icons/md";

const DashboardRange = ({
    handleSubmit,
    autoScaleY,
    setAutoScaleY,
    resetUpperYaxes,
    inputMaxYUpper,
    setInputMaxYUpper,
    inputMinYUpper,
    setInputMinYUpper,
    resetLowerYaxes,
    inputMaxYLower,
    setInputMaxYLower,
    inputMinYLower,
    setInputMinYLower,
    selectedFromDateRange,
    setSelectedFromDateRange,
    selectedFromTimeRange,
    setSelectedFromTimeRange,
    selectedToDateRange,
    setSelectedToDateRange,
    selectedToTimeRange,
    setSelectedToTimeRange,
    handleDownloadCsvButton
}) => {
    return (
        <form className='dashboard-main-range' onSubmit={handleSubmit}>
                <div className="dashboard-date-time-range-container">
                    <label className="dashboard-auto-scale">
                        <input type="checkbox" checked={autoScaleY} onChange={(event) => setAutoScaleY(event.target.checked)} />
                        Auto-scale Y
                    </label>
                    <div className="dashboard-wrapper-y">
                        <button type="button" className="dashboard-button-reset" aria-label="Reset upper Y axis" onClick={resetUpperYaxes}> <RiResetLeftFill /> </button>
                        <div className="dashboard-max-min-div">
                            <div className="inline-flex">
                                <div><MdOutlineKeyboardDoubleArrowUp/>MAX:</div>
                                <InputNumber 
                                    parameter={inputMaxYUpper}
                                    handleInputNumber={handleChangeNumber(setInputMaxYUpper)}
                                    classNameStyle={'dashboard-date-time-range-input'}
                                />    
                            </div>
                            <div className="inline-flex" >
                                <div><MdOutlineKeyboardDoubleArrowUp/>MIN:</div>
                                <InputNumber 
                                    parameter={inputMinYUpper}
                                    handleInputNumber={handleChangeNumber(setInputMinYUpper)}
                                    classNameStyle={'dashboard-date-time-range-input'}
                                />
                            </div>
                        </div>                        
                    </div>
                    
                    <div className="dashboard-wrapper-y">
                        <button type="button" className="dashboard-button-reset" aria-label="Reset lower Y axis" onClick={resetLowerYaxes}> <RiResetLeftFill /> </button>
                        <div className="dashboard-max-min-div">
                            <div className="inline-flex">
                                <div><MdOutlineKeyboardDoubleArrowDown/>MAX:</div>
                                <InputNumber 
                                    parameter={inputMaxYLower}
                                    handleInputNumber={handleChangeNumber(setInputMaxYLower)}
                                    classNameStyle={'dashboard-date-time-range-input'}
                                />    
                            </div>
                            <div className="inline-flex">
                                <div><MdOutlineKeyboardDoubleArrowDown/>MIN:</div>
                                <InputNumber 
                                    parameter={inputMinYLower}
                                    handleInputNumber={handleChangeNumber(setInputMinYLower)}
                                    classNameStyle={'dashboard-date-time-range-input'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard-date-time-container added-margins">
                    FROM:
                    <div className="dashboard-date-time-range-container added-margins">    
                        <DateInput 
                            selectedDate={selectedFromDateRange}
                            handleSelectedDate={handleChange(setSelectedFromDateRange)}
                        />
                        <TimeInput 
                            selectedTime={selectedFromTimeRange}
                            handleSelectedTime={handleChange(setSelectedFromTimeRange)}
                        /> 
                    </div>
                </div>
                <div className="dashboard-date-time-container added-margins">
                    TO:
                    <div className="dashboard-date-time-range-container added-margins">
                        <DateInput 
                            selectedDate={selectedToDateRange}
                            handleSelectedDate={handleChange(setSelectedToDateRange)}
                        />
                        <TimeInput 
                            selectedTime={selectedToTimeRange}
                            handleSelectedTime={handleChange(setSelectedToTimeRange)}
                        />
                    </div>
                </div>
                <button type='submit' className='dashboard-button dashboard-button-submit added-margins'>
                    Confirm <IoMdCheckmark/>
				</button>
                <button type="button" onClick={handleDownloadCsvButton} className='dashboard-button dashboard-button-excel'>
					Download CSV <FaFileExcel />
				</button>
		</form>
    )
}

export default DashboardRange;
